import {Avatar, Badge, Box, Divider, Flex, Text} from "@chakra-ui/react";
import React from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";



export default function UpCommingReviews({upcommingreviews}) {
    console.log(upcommingreviews);
    const navigate = useNavigate();

    const { t } = useTranslation('studentLocal');
    return (<Box>
            <Text fontSize="lg" fontWeight={700} color="gray.800" mb={4}>
                {t('upcommingReview')}
            </Text>
            {upcommingreviews.map((s, index) =>
                index < 6 && (
                <Box key={s.studentId || index} onClick={() => navigate(`/students-profile/${s.studentId}`)} _hover={{ color: 'blue.600', background: 'gray.50' }} cursor="pointer" py={2} px={2} borderRadius="md" transition="background 0.15s">
                <Flex justifyContent={"space-between"}>
                    <Flex>


                        <Avatar src={s.studentImage} name={s.studentName}/>
                        <Box ml='3'>
                            <Text fontWeight='bold'>
                                {s.studentName}
                            </Text>
                            <Text fontSize='sm'>{`IEP of ${s.year}`}</Text>
                        </Box>
                    </Flex>
                    <Box>
                        <Badge ml='1' colorScheme={index % 2 === 0 ? 'green' : 'yellow'}>
                            {new Date(s.reviewTimestamp).toDateString()}
                        </Badge>
                    </Box>
                </Flex>


                <Divider mt={2} mb={2} borderColor="gray.200" />
            </Box>
                )
            )}
        </Box>)
}
